var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * CZNA-1625 — the save banner's content when nobody knows whether the save happened.
 *
 * See `utils/saveOutcomeUnknown.ts` for why this exists. Two shapes:
 *
 *  - an EDIT (`verify`): the sentence plus "Načíst znovu". The click asks the host to re-read
 *    the stored entity; this component only says what the host found. `saved` needs nothing
 *    here — the host has announced it and moved on (or holds the form open, and RecordForm
 *    clears the banner). `notSaved` replaces the warning with the plain fact that nothing was
 *    written and the edits are still in the form. `unverified` keeps the warning and the
 *    button, and says the check itself failed.
 *  - a CREATE (`checkList`): the sentence plus a link to the list where a created entity would
 *    show up, in a new window — the form must stay filled in case it was not created.
 *
 * The verification state lives here, not in RecordForm: a new failure is a new element (the
 * caller keys it), so a stale "nepodařilo se ověřit" can never sit under the next timeout.
 */
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@folio/stripes/components';
var SaveOutcomeUnknownNotice = function (_a) {
    var failure = _a.failure, runVerify = _a.runVerify;
    var _b = useState(false), verifying = _b[0], setVerifying = _b[1];
    var _c = useState(null), outcome = _c[0], setOutcome = _c[1];
    var recovery = failure.recovery;
    if (outcome === 'notSaved') {
        return (React.createElement("span", { role: "status", "data-test-save-timeout-not-saved": true },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.saveTimeout.notSaved" })));
    }
    var reload = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (recovery.kind !== 'verify')
                        return [2 /*return*/];
                    setVerifying(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, runVerify(recovery.verify)];
                case 2:
                    result = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    // A host's verify reports a failed read as `unverified`; anything it throws means the same.
                    result = 'unverified';
                    return [3 /*break*/, 4];
                case 4:
                    setVerifying(false);
                    setOutcome(result);
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { "data-test-save-timeout": true },
        React.createElement("div", { "data-test-save-timeout-message": true }, failure.message),
        outcome === 'unverified' && (React.createElement("div", { role: "status", "data-test-save-timeout-unverified": true, style: { marginTop: '8px' } },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.saveTimeout.unverified" }))),
        recovery.kind === 'verify' && (React.createElement("div", { style: { marginTop: '8px' } },
            React.createElement(Button, { marginBottom0: true, onClick: reload, disabled: verifying, "data-test-save-timeout-reload": true },
                React.createElement(FormattedMessage, { id: verifying ? 'ui-czna-authorities.saveTimeout.verifying' : 'ui-czna-authorities.saveTimeout.reload' })))),
        recovery.kind === 'checkList' && (React.createElement("div", { style: { marginTop: '8px' } },
            React.createElement("a", { href: recovery.href, target: "_blank", rel: "noopener noreferrer", "data-test-save-timeout-list-link": true },
                React.createElement(FormattedMessage, { id: recovery.linkLabelId }))))));
};
export default SaveOutcomeUnknownNotice;
